"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __1 = require("../");
var StoreLocatorProvider = /** @class */ (function (_super) {
    __extends(StoreLocatorProvider, _super);
    function StoreLocatorProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            storeLocator: null,
        };
        return _this;
    }
    StoreLocatorProvider.prototype.componentDidMount = function () {
        var storeLocator;
        if (this.props.hasOwnProperty("storeLocator")) {
            storeLocator = this.props.storeLocator;
        }
        if (this.props.hasOwnProperty("storeLocatorOptions")) {
            storeLocator = new __1.StoreLocator(this.props.storeLocatorOptions);
        }
        storeLocator.setProvider(this);
        this.setState({
            storeLocator: storeLocator,
        });
    };
    StoreLocatorProvider.prototype.render = function () {
        if (!this.state || !this.state.storeLocator) {
            return null;
        }
        return (React.createElement(__1.Context.Provider, { value: {
                storeLocator: this.state.storeLocator,
            } }, this.props.children));
    };
    StoreLocatorProvider.contextType = __1.Context;
    return StoreLocatorProvider;
}(React.Component));
exports.StoreLocatorProvider = StoreLocatorProvider;
//# sourceMappingURL=store-locator-provider.js.map